import HeaderPortal from "components/portal/header-portal";
import List from "components/list";
import React from "react";
import { useParams } from "react-router-dom";
import CreateItemButton from "components/buttons/create";
import { PermissionGate } from "permissions/components/gate";
import { TypeCell } from "@/modules/reports/billables/extension/cells";
import { StatusCell } from "@/components/status/cell";
import { useProject } from "../context";
import { ROUTE } from "@/lib/utils";

export default function ProjectContracts() {
  const { project_slug } = useParams();
  const { id } = useProject();
  const fields = [
    "id",
    "name",
    "type",
    "status",
    "jobs.id",
    "jobs.name",
    "project.id",
    "project.project_id",
  ];
  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: TypeCell,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "jobs.id",
      header: "Job",
      accessorKey: "job",
      cell: ({ row }) => {
        const job = row.original.jobs;
        if (!job) return null;
        return job.length;
      },
    },
  ];

  const defaultFilters = {
    project: {
      _eq: id,
    },
  };

  return (
    <>
      <HeaderPortal>
        <PermissionGate
          rule="create:FIN,AM"
          collection="contracts"
          showWhenDisabled={false}
        >
          <CreateItemButton href>Contract</CreateItemButton>
        </PermissionGate>
      </HeaderPortal>
      <List
        title="Contracts"
        storageKey={project_slug}
        endPoint="contracts"
        columns={columns}
        meta={{ fields }}
        filters={defaultFilters}
        href={(item) => ROUTE.CONTRACT(item.id)}
      />
    </>
  );
}
